import { render, staticRenderFns } from "./LinkProductTags.vue?vue&type=template&id=66f976f3&scoped=true&"
import script from "./LinkProductTags.vue?vue&type=script&lang=js&"
export * from "./LinkProductTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f976f3",
  null
  
)

export default component.exports